// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__GsZNY","loaderInner":"loader_loaderInner__1HJki","loader-inner":"loader_loader-inner__3v04P"};